import { AxiosError } from 'axios';
import { translate } from './translate';

export const processResponseErrors = (error: AxiosError) => (error.response?.data as any)?.errors || [{ code: '', message: translate({ key: error.message }) || translate({ key: 'error.common', fallback: 'Undefined Error' }) }];
